import { Attrs, MinzeElement } from 'minze'

export interface LvcDiscoveryArrowRightIcon {
  dataColor?: string
  width?: number
  height?: number
}

export class LvcDiscoveryArrowRightIcon extends MinzeElement {
  attrs: Attrs = [['data-color'], ['width', 47], ['height', 47]]

  html = () => `
  <svg width="45" height="14" viewBox="0 0 45 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30.8864 7.12726C28.582 7.16346 26.4653 7.18185 24.3369 7.23304C18.9885 7.3549 13.6288 7.48752 8.28008 7.62038C6.37225 7.66553 4.46441 7.71067 2.55708 7.73378C2.04983 7.74439 1.53205 7.73271 1.03879 7.61136C0.589354 7.50203 0.23402 7.13029 0.366382 6.63728C0.450454 6.33056 0.711784 5.98375 0.990673 5.83573C1.29209 5.66618 1.6997 5.67537 2.06374 5.66154C3.67462 5.58765 5.28551 5.51376 6.90642 5.48419C14.6036 5.31612 22.3113 5.17032 30.0082 5.01327C30.2839 5.00846 30.5723 4.92679 30.8487 4.88894C31.295 4.16053 31.0805 3.40619 31.1405 2.70213C31.185 2.19612 31.1967 1.67835 31.318 1.18509C31.4399 0.669804 32.2425 0.26907 32.735 0.423465C32.9431 0.483268 33.1614 0.576369 33.3349 0.701526C36.0781 2.7143 39.1785 4.04074 42.255 5.4438C42.8442 5.7106 43.4204 6.06528 43.9405 6.46278C44.4929 6.89408 44.4617 7.78616 43.9015 8.19236C43.4869 8.49163 43.019 8.71254 42.5513 8.92243C39.7133 10.137 36.9076 11.3853 34.2381 12.9453C33.7467 13.2319 33.1694 13.4172 32.6046 13.5368C31.9621 13.6766 31.3877 13.2448 31.5133 12.5642C31.6891 11.6093 30.9551 10.9204 31.0306 10.0183C31.1056 9.13822 31.1805 8.25815 30.8864 7.12726Z" fill="white"/>
</svg>

  
  `

  css = () => `
    :host {
      width: ${this.width}px;
      height: ${this.height}px;
      display:flex;
      align-items:center;
    }
  `
}
